module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/81.1a9ed507.png";